import Gun from "gun";
import 'gun/gun/sea';
import "gun/lib/webrtc";

let peers;

if (process.env.NODE_ENV === "development") {
  peers = ["http://localhost:8765/gun"  ,"https://gun-manhattan.herokuapp.com/gun",
  "https://relay.129.153.59.37.nip.io/gun",
  "https://relay.peer.ooo/gun",
  "https://peer.wallie.io/gun",
  "www-dweb-gun.dev.archive.org/gun",];
} else {
  peers = [
    // Community relay peers: https://github.com/amark/gun/wiki/volunteer.dht
    "https://gun-manhattan.herokuapp.com/gun",
    "https://relay.129.153.59.37.nip.io/gun",
    "https://relay.peer.ooo/gun",
    "https://peer.wallie.io/gun",
    "www-dweb-gun.dev.archive.org/gun",
    // My own relay peer
    // "https://phrassed.com/gun",
  ];
}

// export const gun = new Gun({
//   peers,
// });
export const gun = new Gun({
  peers,
});

// export const userid = gun.user().recall({sessionStorage: true});

// attaching gun to window for testing purposes
window.gun = gun;
